export default __webpack_public_path__ + "static/media/sleep.6d1522e9.svg";